import React from 'react';

import TermsOfService from 'components/common/templates/TermsOfService';
import ScrollableContainer from 'components/common/atoms/ScrollableContainer';
import StandardContentWrapper from 'components/common/atoms/StandardContentWrapper';


function ToSModal() {
    return (
        <ScrollableContainer>
            <StandardContentWrapper>
                <TermsOfService />
            </StandardContentWrapper>
        </ScrollableContainer>
    );
}

export default ToSModal;
